<template>
  <div>
    <h2>{{ $t('title.external-services') }}</h2>

    <base-list
      model="external-services"
      :columns="['id', 'type', 'url']"
      sModel="external-service"
      />
  </div>


</template>

<script>
import BaseList from 'components/BaseList'

export default {
  name: 'external-service-list',
  components: { BaseList }
}
</script>


// WEBPACK FOOTER //
// ExternalServiceList.vue?ec843d7e